import { render, staticRenderFns } from "./selectbarcode.vue?vue&type=template&id=fc8ef856&"
import script from "./selectbarcode.vue?vue&type=script&lang=ts&"
export * from "./selectbarcode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports